import _defaults from 'lodash/defaults'

export default {
  getters: {
    Payment: (state, getters) => {
      return _defaults(
        getters.currentTripDashboardId ? getters.Trips[getters.currentTripDashboardId].payment : {},
        {
          'section-heading': 'Invoice & Payment Info',
          'section-subheading': '',
          'make-payment-intro': 'Please pick your payment method below:',

          'payment-method-wire-direct-to': getters.Settings.payment_method_wire_direct_to,
          'payment-method-wire-swift-code': getters.Settings.payment_method_wire_swift_code,
          'payment-method-wire-bank-address': getters.Settings.payment_method_wire_bank_address,
          'payment-method-wire-beneficiary-address':
            getters.Settings.payment_method_wire_beneficiary_address,
          'payment-method-wire-bank-name': getters.Settings.payment_method_wire_bank_name,
          'payment-method-wire-account-name': getters.Settings.payment_method_wire_account_name,
          'payment-method-wire-account-number': getters.Settings.payment_method_wire_account_number,

          'payment-method-check-payable-to': getters.Settings.payment_method_check_payable_to,
          'payment-method-check-regular-send-to-heading': 'For Checks sent by regular email',
          'payment-method-check-regular-send-to-body':
            getters.Settings.payment_method_check_regular_send_to_body,
          'payment-method-check-alt-send-to-heading':
            getters.Settings.payment_method_check_alt_send_to_heading,
          'payment-method-check-alt-send-to-body':
            getters.Settings.payment_method_check_alt_send_to_body
        }
      )
    }
  }
}
